// ============================================================
//  ALTIMO Medical Center — Medicos.jsx  (v1.1)
//  Fix: quitar Dr./Dra. del display, Otra especialidad = campo libre,
//       agregar columna telefono en migration
// ============================================================

import { useState, useEffect, useCallback } from 'react';
import api from '../apiClient';
import { useConfirmar } from './ModalConfirmar';

const ESPECIALIDADES = [
  'Medicina General','Cirugía General','Pediatría','Ginecología y Obstetricia',
  'Cardiología','Neurología','Ortopedia y Traumatología','Oftalmología',
  'Otorrinolaringología','Dermatología','Urología','Gastroenterología',
  'Neumología','Endocrinología','Reumatología','Oncología',
  'Psiquiatría','Anestesiología','Radiología e Imagen','Medicina Interna',
  'Emergenciología','Nefrología','Hematología','Infectología','Otra',
];

const S = {
  pagina:{ background:'#f0f4f8', minHeight:'100vh', padding:'20px', fontFamily:'Segoe UI, sans-serif' },
  card:  { background:'#fff', borderRadius:'10px', border:'1px solid #dde3ea', padding:'18px', marginBottom:'16px' },
  titulo:{ fontSize:'12px', fontWeight:'700', color:'#1B2A5E', textTransform:'uppercase', letterSpacing:'.05em', marginBottom:'14px', paddingBottom:'10px', borderBottom:'2px solid #e8f0fb', display:'flex', justifyContent:'space-between', alignItems:'center' },
  input: { width:'100%', fontSize:'13px', padding:'8px 10px', border:'1px solid #c0ccda', borderRadius:'7px', background:'#fff', color:'#333', outline:'none', boxSizing:'border-box' },
  label: { display:'block', fontSize:'11px', fontWeight:'600', color:'#6c757d', marginBottom:'4px', textTransform:'uppercase', letterSpacing:'.04em' },
  campo: { marginBottom:'12px' },
  fila2: { display:'grid', gridTemplateColumns:'1fr 1fr', gap:'12px' },
  fila3: { display:'grid', gridTemplateColumns:'1fr 1fr 1fr', gap:'12px' },
  tabla: { width:'100%', borderCollapse:'collapse', fontSize:'13px' },
  th:    { textAlign:'left', padding:'8px 12px', fontSize:'11px', color:'#6c757d', fontWeight:'600', borderBottom:'2px solid #e8f0fb', background:'#f8fafd' },
  td:    { padding:'10px 12px', borderBottom:'1px solid #eef1f6', color:'#333' },
  btnVerde:{ background:'#1D9E75', color:'#fff', border:'none', borderRadius:'7px', padding:'8px 18px', fontSize:'12px', fontWeight:'600', cursor:'pointer' },
  btnAzul: { background:'#1B2A5E', color:'#fff', border:'none', borderRadius:'7px', padding:'7px 14px', fontSize:'12px', fontWeight:'600', cursor:'pointer' },
  btnRojo: { background:'#dc3545', color:'#fff', border:'none', borderRadius:'7px', padding:'7px 14px', fontSize:'12px', fontWeight:'600', cursor:'pointer' },
  btnS:    { background:'#fff', color:'#495057', border:'1px solid #c0ccda', borderRadius:'7px', padding:'7px 12px', fontSize:'12px', cursor:'pointer' },
  alerta:(t) => ({
    padding:'10px 14px', borderRadius:'8px', fontSize:'13px', fontWeight:'500', marginBottom:'12px',
    background:t==='ok'?'#d4edda':t==='err'?'#f8d7da':'#fff3cd',
    color:t==='ok'?'#155724':t==='err'?'#721c24':'#856404',
    border:`1px solid ${t==='ok'?'#c3e6cb':t==='err'?'#f5c6cb':'#ffc107'}`,
  }),
  modal:    { position:'fixed',top:0,left:0,right:0,bottom:0,background:'rgba(0,0,0,0.45)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:1000 },
  modalCard:{ background:'#fff',borderRadius:'12px',padding:'28px',width:'520px',maxHeight:'90vh',overflowY:'auto',border:'1px solid #dde3ea' },
  pill:(activo)=>({ display:'inline-block',padding:'2px 10px',borderRadius:'99px',fontSize:'10px',fontWeight:'700',background:activo?'#d4edda':'#f8d7da',color:activo?'#155724':'#721c24' }),
  espBadge:{ display:'inline-block',padding:'2px 8px',borderRadius:'4px',fontSize:'10px',fontWeight:'600',background:'#e8f0fb',color:'#1B2A5E' },
  avatar:(activo)=>({ width:'38px',height:'38px',borderRadius:'50%',background:activo?'#1B2A5E':'#adb5bd',display:'flex',alignItems:'center',justifyContent:'center',color:'#fff',fontSize:'14px',fontWeight:'700',flexShrink:0 }),
};

const FORM_VACIO = {
  nombre:'', apellido:'', titulo:'Dr.',
  especialidad:'Medicina General', especialidadLibre:'',
  telefono:'', correo:'', num_junta:'', consultorio:'', observaciones:'',
};

export default function Medicos({ usuario }) {
  const [medicos,   setMedicos]   = useState([]);
  const [busqueda,  setBusqueda]  = useState('');
  const [filtroEsp, setFiltroEsp] = useState('Todas');
  const [filtroAct, setFiltroAct] = useState('activos');
  const [modal,     setModal]     = useState(null);
  const [form,      setForm]      = useState(FORM_VACIO);
  const [mensaje,   setMensaje]   = useState(null);
  const [guardando, setGuardando] = useState(false);
  const { confirmar, ModalConfirmarUI } = useConfirmar();

  const cargar = useCallback(async () => {
    const r = await api.medicos.listar();
    if (r.ok) setMedicos(r.data);
  }, []);

  useEffect(() => { cargar(); }, [cargar]);

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const abrirNuevo = () => { setForm(FORM_VACIO); setModal('nuevo'); setMensaje(null); };

  const abrirEditar = (m) => {
    // Detectar si la especialidad guardada es "Otra" o una libre
    const espEnLista = ESPECIALIDADES.includes(m.especialidad);
    setForm({
      nombre:         m.nombre        || '',
      apellido:       m.apellido      || '',
      titulo:         m.titulo        || 'Dr.',
      especialidad:   espEnLista ? m.especialidad : 'Otra',
      especialidadLibre: espEnLista ? '' : (m.especialidad || ''),
      telefono:       m.telefono      || '',
      correo:         m.correo        || '',
      num_junta:      m.num_junta     || '',
      consultorio:    m.consultorio   || '',
      observaciones:  m.observaciones || '',
    });
    setModal(m); setMensaje(null);
  };

  // Especialidad efectiva a guardar
  const especialidadEfectiva = form.especialidad === 'Otra'
    ? (form.especialidadLibre.trim() || 'Otra')
    : form.especialidad;

  const guardar = async () => {
    if (!form.nombre || !form.apellido) {
      setMensaje({ tipo:'err', texto:'Nombre y apellido son obligatorios.' }); return;
    }
    if (form.especialidad === 'Otra' && !form.especialidadLibre.trim()) {
      setMensaje({ tipo:'err', texto:'Especifica el tipo de médico.' }); return;
    }
    setGuardando(true);
    const payload = {
      nombre: form.nombre, apellido: form.apellido, titulo: form.titulo,
      especialidad: especialidadEfectiva,
      telefono: form.telefono, correo: form.correo,
      num_junta: form.num_junta, consultorio: form.consultorio,
      observaciones: form.observaciones,
    };
    let r;
    if (modal === 'nuevo') r = await api.medicos.crear(payload);
    else                   r = await api.medicos.editar({ id: modal.id, ...payload });
    setGuardando(false);
    if (r.ok) {
      setModal(null); cargar();
      setMensaje({ tipo:'ok', texto: modal==='nuevo' ? 'Médico registrado correctamente.' : 'Datos actualizados.' });
      setTimeout(() => setMensaje(null), 4000);
    } else {
      setMensaje({ tipo:'err', texto: r.error });
    }
  };

  const toggleActivo = async (m) => {
    const nuevoEstado = m.activo ? 0 : 1;
    if (!(await confirmar({
      texto: `¿Deseas ${nuevoEstado?'activar':'desactivar'} a ${m.nombre} ${m.apellido}?`,
      tipo: 'advertencia',
      textoConfirmar: nuevoEstado ? 'Activar' : 'Desactivar',
    }))) return;
    const r = await api.medicos.toggle({ id: m.id, activo: nuevoEstado });
    if (r.ok) cargar(); else setMensaje({ tipo:'err', texto: r.error });
  };

  const iniciales = (m) => `${m.nombre?.charAt(0)||''}${m.apellido?.charAt(0)||''}`.toUpperCase();

  const especialidadesDisponibles = [...new Set(medicos.map(m => m.especialidad).filter(Boolean))].sort();

  const filtrados = medicos.filter(m => {
    const txt = `${m.nombre} ${m.apellido} ${m.especialidad||''} ${m.num_junta||''}`.toLowerCase();
    return (!busqueda || txt.includes(busqueda.toLowerCase()))
      && (filtroEsp==='Todas' || m.especialidad===filtroEsp)
      && (filtroAct==='todos' || (filtroAct==='activos' ? m.activo : !m.activo));
  });

  return (
    <div style={{ fontFamily:'Segoe UI, sans-serif' }}>
      {ModalConfirmarUI}
      {/* ══ Header módulo — estandarizado ══ */}
      <div style={{ background:'linear-gradient(135deg,#1B2A5E,#0f1c40)', padding:'16px 24px' }}>
        <div style={{ fontSize:'19px', fontWeight:'800', color:'#fff', marginBottom:'3px' }}>
          🩺 Módulo de Médicos
        </div>
        <div style={{ fontSize:'12px', color:'rgba(255,255,255,.8)' }}>
          Registro de médicos · Especialidades · Datos de contacto
        </div>
      </div>

      <div style={S.pagina}>
      {mensaje && !modal && <div style={S.alerta(mensaje.tipo)}>{mensaje.texto}</div>}

      <div style={S.card}>
        <div style={S.titulo}>
          <span>🩺 Médicos del hospital ({filtrados.length})</span>
          <button style={S.btnVerde} onClick={abrirNuevo}>+ Registrar médico</button>
        </div>

        <div style={{ display:'flex', gap:'10px', marginBottom:'16px', flexWrap:'wrap', alignItems:'center' }}>
          <input style={{ ...S.input, maxWidth:'260px' }}
            placeholder="Buscar por nombre, especialidad, junta..."
            value={busqueda} onChange={e=>setBusqueda(e.target.value)} />
          <select style={{ ...S.input, width:'auto' }} value={filtroEsp} onChange={e=>setFiltroEsp(e.target.value)}>
            <option value="Todas">Todas las especialidades</option>
            {especialidadesDisponibles.map(e=><option key={e} value={e}>{e}</option>)}
          </select>
          {['activos','inactivos','todos'].map(f=>(
            <button key={f} onClick={()=>setFiltroAct(f)}
              style={{ padding:'6px 14px',borderRadius:'7px',fontSize:'12px',fontWeight:'600',cursor:'pointer',border:'none',background:filtroAct===f?'#1B2A5E':'#e8f0fb',color:filtroAct===f?'#fff':'#1B2A5E' }}>
              {f.charAt(0).toUpperCase()+f.slice(1)}
            </button>
          ))}
        </div>

        <table style={S.tabla}>
          <thead>
            <tr>{['','Nombre','Especialidad','Junta / Colegio','Teléfono','Consultorio','Estado','Acciones'].map(h=>(
              <th key={h} style={S.th}>{h}</th>
            ))}</tr>
          </thead>
          <tbody>
            {filtrados.map(m=>(
              <tr key={m.id} onMouseEnter={e=>e.currentTarget.style.background='#f8fafd'} onMouseLeave={e=>e.currentTarget.style.background='transparent'}>
                <td style={S.td}><div style={S.avatar(m.activo)}>{iniciales(m)}</div></td>
                <td style={S.td}>
                  {/* SIN Dr./Dra. hardcodeado — se muestra el título guardado */}
                  <div style={{ fontWeight:'700',color:'#1B2A5E' }}>
                    {m.titulo ? `${m.titulo} ` : ''}{m.nombre} {m.apellido}
                  </div>
                  {m.correo && <div style={{ fontSize:'11px',color:'#6c757d',marginTop:'2px' }}>{m.correo}</div>}
                </td>
                <td style={S.td}><span style={S.espBadge}>{m.especialidad||'—'}</span></td>
                <td style={{ ...S.td,fontSize:'12px',color:'#6c757d' }}>{m.num_junta||'—'}</td>
                <td style={{ ...S.td,fontSize:'12px' }}>{m.telefono||'—'}</td>
                <td style={{ ...S.td,fontSize:'12px' }}>{m.consultorio||'—'}</td>
                <td style={S.td}><span style={S.pill(m.activo)}>{m.activo?'Activo':'Inactivo'}</span></td>
                <td style={S.td}>
                  <div style={{ display:'flex',gap:'6px' }}>
                    <button style={S.btnAzul} onClick={()=>abrirEditar(m)}>Editar</button>
                    <button style={m.activo?S.btnRojo:S.btnVerde} onClick={()=>toggleActivo(m)}>
                      {m.activo?'Desactivar':'Activar'}
                    </button>
                  </div>
                </td>
              </tr>
            ))}
            {filtrados.length===0 && (
              <tr><td colSpan="8" style={{ ...S.td,textAlign:'center',color:'#adb5bd',padding:'30px' }}>No se encontraron médicos.</td></tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Modal */}
      {modal !== null && (
        <div style={S.modal} onClick={()=>setModal(null)}>
          <div style={S.modalCard} onClick={e=>e.stopPropagation()}>
            <div style={{ fontSize:'15px',fontWeight:'800',color:'#1B2A5E',marginBottom:'20px' }}>
              {modal==='nuevo' ? '➕ Registrar nuevo médico' : `✏️ Editar: ${modal.nombre} ${modal.apellido}`}
            </div>
            {mensaje && <div style={S.alerta(mensaje.tipo)}>{mensaje.texto}</div>}

            {/* Título y nombre */}
            <div style={{ display:'grid',gridTemplateColumns:'90px 1fr 1fr',gap:'12px',marginBottom:'0' }}>
              <div style={S.campo}>
                <label style={S.label}>Título</label>
                <select style={S.input} value={form.titulo} onChange={e=>set('titulo',e.target.value)}>
                  <option value="Dr.">Dr.</option>
                  <option value="Dra.">Dra.</option>
                  <option value="Lic.">Lic.</option>
                  <option value="Téc.">Téc.</option>
                  <option value="">Sin título</option>
                </select>
              </div>
              <div style={S.campo}>
                <label style={S.label}>Nombre *</label>
                <input style={S.input} value={form.nombre} onChange={e=>set('nombre',e.target.value)} placeholder="Primer nombre" />
              </div>
              <div style={S.campo}>
                <label style={S.label}>Apellido *</label>
                <input style={S.input} value={form.apellido} onChange={e=>set('apellido',e.target.value)} placeholder="Primer apellido" />
              </div>
            </div>

            {/* Especialidad */}
            <div style={S.campo}>
              <label style={S.label}>Especialidad *</label>
              <select style={S.input} value={form.especialidad} onChange={e=>set('especialidad',e.target.value)}>
                {ESPECIALIDADES.map(e=><option key={e} value={e}>{e}</option>)}
              </select>
            </div>

            {/* Campo libre si elige "Otra" */}
            {form.especialidad==='Otra' && (
              <div style={{ ...S.campo, background:'#fff8e1',border:'2px solid #ffe082',borderRadius:'8px',padding:'12px' }}>
                <label style={{ ...S.label,color:'#e65100' }}>Especifica el tipo de médico *</label>
                <input
                  style={{ ...S.input,border:'2px solid #ff9800' }}
                  value={form.especialidadLibre}
                  onChange={e=>set('especialidadLibre',e.target.value)}
                  placeholder="Ej: Médico forense, Fisiatra, Homeópata..."
                  autoFocus
                />
              </div>
            )}

            <div style={S.fila2}>
              <div style={S.campo}>
                <label style={S.label}>N° Junta / Colegio Médico</label>
                <input style={S.input} value={form.num_junta} onChange={e=>set('num_junta',e.target.value)} placeholder="JM-0001234" />
              </div>
              <div style={S.campo}>
                <label style={S.label}>Teléfono</label>
                <input style={S.input} value={form.telefono} onChange={e=>set('telefono',e.target.value)} placeholder="0000-0000" />
              </div>
            </div>
            <div style={S.fila2}>
              <div style={S.campo}>
                <label style={S.label}>Correo electrónico</label>
                <input style={S.input} value={form.correo} onChange={e=>set('correo',e.target.value)} placeholder="dr@altimo.com" />
              </div>
              <div style={S.campo}>
                <label style={S.label}>Consultorio asignado</label>
                <input style={S.input} value={form.consultorio} onChange={e=>set('consultorio',e.target.value)} placeholder="Clínica 2, Piso 1" />
              </div>
            </div>
            <div style={S.campo}>
              <label style={S.label}>Observaciones / Horario</label>
              <textarea style={{ ...S.input,resize:'vertical',minHeight:'60px' }}
                value={form.observaciones} onChange={e=>set('observaciones',e.target.value)}
                placeholder="Lunes a viernes 8am-12pm..." />
            </div>

            <div style={{ display:'flex',gap:'10px',marginTop:'8px' }}>
              <button style={S.btnVerde} onClick={guardar} disabled={guardando}>{guardando?'Guardando...':'✓ Guardar'}</button>
              <button style={S.btnS} onClick={()=>setModal(null)}>Cancelar</button>
            </div>
          </div>
        </div>
      )}
      </div>
    </div>
  );
}
